"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgActivity = function SvgActivity(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M11.195 12.817l3.862 13.642c.42 1.483 2.534 1.445 2.9-.052l3.795-15.526 2.409 7.154a1.5 1.5 0 001.421 1.022h3.83a1.5 1.5 0 000-3H26.66L22.945 5.02c-.48-1.423-2.522-1.337-2.879.123l-3.672 15.024L12.958 8.03c-.381-1.348-2.239-1.484-2.812-.205l-3.692 8.232H3.5a1.5 1.5 0 000 3h3.926a1.5 1.5 0 001.368-.886l2.401-5.354z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "activity_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 2,
      y: 4,
      width: 29,
      height: 24,
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M11.195 12.817l3.862 13.642c.42 1.483 2.534 1.445 2.9-.052l3.795-15.526 2.409 7.154a1.5 1.5 0 001.421 1.022h3.83a1.5 1.5 0 000-3H26.66L22.945 5.02c-.48-1.423-2.522-1.337-2.879.123l-3.672 15.024L12.958 8.03c-.381-1.348-2.239-1.484-2.812-.205l-3.692 8.232H3.5a1.5 1.5 0 000 3h3.926a1.5 1.5 0 001.368-.886l2.401-5.354z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#activity_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fill: fill || theme.colors.primary.main,
        d: "M-59-59H90.747V91H-59z"
      })
    })]
  }));
};

var _default = SvgActivity;
exports["default"] = _default;